import React from 'react'
import { DcInput } from 'pixel-base'
import { OrderSummary } from '../../../../decl'

interface IProps {
  bulkEdit: boolean
  data: OrderSummary[]
  id: number
  placeholder: string
  value: string
  setData: (data: OrderSummary) => void
  cities: {
    name: string
  }[]
}
const SelectCity = (props: IProps) => {
  const { cities, value, setData, data, bulkEdit, id, placeholder } = props
  const [customerLoading, setCustomerLoading] = React.useState(false)
  const [invalid, setInvalid] = React.useState(false)
  const [search, setSearch] = React.useState([])
  const handleSearch = (query) => {
    if (query) {
      const isCity = cities.find((item) => {
        return item.name.toLowerCase() === query.toLowerCase()
      })
      setInvalid(!isCity)
      if (bulkEdit) {
        const newData = data.map((item) => {
          if (item.number === id) {
            item.shipping.city = query
          }
          return item
        })
        setData(newData)
      } else {
        setData({ ...data, city: query })
      }
    }
    setCustomerLoading(true)
    setSearch(
      cities.filter((item) => {
        return item.name.toLowerCase().includes(query.toLowerCase())
      }),
    )
    setCustomerLoading(false)
  }
  React.useEffect(() => {
    const citiesList = cities
    if (citiesList?.length > 0) {
      const isCity = citiesList?.find((item) => {
        return item?.name?.toLowerCase() === value?.toLowerCase()
      })

      if (isCity) {
        setInvalid(false)
      } else {
        setInvalid(true)
      }
    }
  }, [value])

  return (
    <>
      {data?.country_code === 'US' ? (
        <DcInput
          isShowLabel={true}
          required
          name={'name'}
          labelKey={'name'}
          value={value}
          placeholder={placeholder}
          onChange={(e) => {
            setData({ ...data, city: e.target.value })
          }}
        />
      ) : (
        <DcInput
          isShowLabel={false}
          required
          name={'name'}
          as={'typeahead'}
          labelKey={'name'}
          data={search}
          invalid={invalid}
          value={value}
          placeholder={placeholder}
          handleSearch={handleSearch}
          onSelectedOption={() => {
            setInvalid(false)
          }}
          isLoading={customerLoading}
          formatter={(option) => {
            return (
              <div>
                <p>{option.name}</p>
              </div>
            )
          }}
          onChange={(array) => {
            if (array.length === 0) {
              return
            }
            if (bulkEdit) {
              const newData = data.map((item) => {
                if (item.number === id) {
                  item.shipping.city = array[0].name
                }
                return item
              })
              setData(newData)
            } else {
              setData({ ...data, city: array[0].name })
            }
          }}
        />
      )}
    </>
  )
}
export default SelectCity
